module.exports = __webpack_public_path__ + "media/dark.09769951.mp3";